// extracted by mini-css-extract-plugin
export var image = "Image-module--image--af00f";